import {
  AndersenCableLength,
  AndersenA2A3Colours,
  AndersenQuartzColours,
} from "_core/types/charger";
import {
  PRICE_ANDERSEN_QUARTZ_SOCKET,
  PRICE_ANDERSEN_QUARTZ_5_5M,
  PRICE_ANDERSEN_QUARTZ_8_5M,
  PRICE_ANDERSEN_A3_BASE,
  PRICE_ANDERSEN_A3_PREMIUM,
  PRICE_ANDERSEN_A2_BASE,
  PRICE_ANDERSEN_A2_PREMIUM,
} from "_core/config/prices";
import { CableSetup } from "_core/types";

export const ANDERSEN_QUARTZ_CABLE_SETUP: {
  value: CableSetup;
  label: string;
  price: number;
}[] = [
  {
    label: "Untethered",
    price: PRICE_ANDERSEN_QUARTZ_SOCKET,
    value: CableSetup.UNTETHERED,
  },
  {
    label: "Tethered",
    price: PRICE_ANDERSEN_QUARTZ_5_5M,
    value: CableSetup.TETHERED,
  },
];

export const ANDERSEN_QUARTZ_CABLES: {
  value: AndersenCableLength;
  label: string;
  price: number;
}[] = [
  {
    label: "5.5m cable",
    price: PRICE_ANDERSEN_QUARTZ_5_5M,
    value: "5.5m",
  },
  {
    label: "8.5m cable",
    price: PRICE_ANDERSEN_QUARTZ_8_5M,
    value: "8.5m",
  },
];

export const ANDERSEN_A2_COLOURS: {
  value: AndersenA2A3Colours;
  label: string;
  price: number;
}[] = [
  {
    value: "MidnightBlack_MidnightBlack",
    label: "Midnight Black Front and Sides",
    price: PRICE_ANDERSEN_A2_BASE,
  },
  {
    value: "CheltenhamGraphite_CheltenhamGraphite",
    label: "Cheltenham Graphite Front and Sides",
    price: PRICE_ANDERSEN_A2_BASE,
  },
  {
    value: "CotswoldOak_CornishCream",
    label: "Cotswold Oak Front Cornish Cream Sides",
    price: PRICE_ANDERSEN_A2_PREMIUM,
  },
];

export const ANDERSEN_A3_COLOURS: {
  value: AndersenA2A3Colours;
  label: string;
  price: number;
}[] = [
  {
    value: "MidnightBlack_MidnightBlack",
    label: "Midnight Black Front and Sides",
    price: PRICE_ANDERSEN_A3_BASE,
  },
  {
    value: "CheltenhamGraphite_CheltenhamGraphite",
    label: "Cheltenham Graphite Front and Sides",
    price: PRICE_ANDERSEN_A3_BASE,
  },
  {
    value: "CotswoldOak_CornishCream",
    label: "Cotswold Oak Front Cornish Cream Sides",
    price: PRICE_ANDERSEN_A3_PREMIUM,
  },
];

export const ANDERSEN_QUARTZ_COLOURS: {
  value: AndersenQuartzColours;
  label: string;
  price: number;
}[] = [
  {
    value: "MidnightBlack_MidnightBlack",
    label: "Midnight Black Front and Sides",
    price: 0,
  },
  {
    value: "CheltenhamGraphite_CheltenhamGraphite",
    label: "Cheltenham Graphite Front and Sides",
    price: 0,
  },
  {
    value: "CotswoldOak_Cashmere",
    label: "Cotswold Oak Front Cashmere Sides",
    price: 150,
  },
];
